function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "M8.5751362,0.0432446h-1.642746v19.4665451L1.16635,13.7437496L0,14.9100981l7.7537632,7.7537642l0.821373-0.7885208 V0.0432446z"
}), React.createElement("path", {
  d: "M10.2835941,20.1340313l5.2239313-5.2239332l-1.1663485-1.1663485l-4.0575829,4.0575829V20.1340313z"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Layer_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15.5075254 22.7071075",
    style: {
      "enableBackground": "new 0 0 15.5075254 22.7071075"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/down-arrow-old.89792fe3.svg";
export { SvgComponent as ReactComponent };